import { useEffect, useState } from "react"
import { appPath } from "../../config/paths"

export default function IconSprite() {
    const [svg, setSvg] = useState("")

    useEffect(() => {
        fetch(appPath("/trust-center/icons.svg"))
            .then((r) => r.text())
            .then(setSvg)
            .catch(() => {})
    }, [])

    if (!svg) return null
    return <div dangerouslySetInnerHTML={{ __html: svg }} aria-hidden="true" />
}
